import PropertyDetails from "./PropertyDetails";

/** Detalhe do imóvel para venda de cota — sem reserva/datas/favoritos */
const PropertySaleDetails = () => <PropertyDetails saleMode />;

export default PropertySaleDetails;
